import * as React from 'react'
import { useMemo } from 'react'

import type { CustomFieldProps } from './typings'
import { AdditionalInfoListItem } from '@sales-center/components'
import { aggregateFieldOptions } from '@user/store/customFields'
import type { CustomFieldSingleValue } from '@sales-center/common'

type CustomSingleSelectProps = CustomFieldProps & {
  value: CustomFieldSingleValue
}

export function CustomSingleSelect(props: CustomSingleSelectProps) {
  const {
    customFields,
    customFieldOptions,
    value: { customFieldId, customFieldOptionId },
  } = props

  const { field, subtitle } = useMemo(() => {
    const field = customFields.find((x) => x.id === customFieldId)

    const options = aggregateFieldOptions(customFieldId, customFieldOptions)

    const option = options.find((x) => x.id === customFieldOptionId)

    const subtitle = option?.name

    return {
      field,
      subtitle,
    }
  }, [customFieldId, customFieldOptionId, customFieldOptions, customFields])

  if (!field) return null

  return <AdditionalInfoListItem title={field.name} subtitle={subtitle} />
}
